import WIcons from './w-icon';
class IconArrowRight extends WIcons {
    contents = `<path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z"/>`;
}
customElements.define( 'icon-arrow-right', IconArrowRight );